const fetchRequest = params => ({
  type: 'FETCH_USERS_REQUEST',
  params,
});

const fetchSuccess = (payload, params) => ({
  type: 'FETCH_USERS_SUCCESS',
  payload,
  params,
});

const fetchError = (error, params) => ({
  type: 'FETCH_USERS_ERROR',
  error,
  params,
});

export const doFetch = (fetchPromise, params) => (dispatch) => {
  dispatch(fetchRequest(params));
  return fetchPromise
    .then(payload => dispatch(fetchSuccess(payload, params)))
    .catch(error => dispatch(fetchError(error, params)));
};

export const fetchClear = () => ({
  type: 'FETCH_USERS_CLEAR',
});

export const updateSelectedTable = selectedTable => ({
  type: 'UPDATE_SELECTED_TABLE',
  selectedTable,
});

export const updateSelectedPage = selectedPage => ({
  type: 'UPDATE_SELECTED_PAGE',
  selectedPage,
});
